import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Container, useMediaQuery,
} from '@mui/material';
import * as actions from "../../../../store/actions";
import { i18n } from '../../../../translate/i18n';
import {
  FormStyled, DivFormTitle
} from '../styles';
import Spinner from '../../../../components/Spinner/index';
import Tabs from '../../../../components/Tabs/TabsEquipment';
import Timeline from '../../../../components/MaintenancesTimeline';
import { Button } from '@mui/material';
import { AddCircleOutline } from '@mui/icons-material';
import { EAccessRole } from '../../../../store/types';

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'space-around',
    minHeight: '10rem',
    flexDirection: 'column',
  },
  servicesContainer: {
    marginTop: '0.5rem',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.75rem 0.5rem'
  },
  title: {
    fontSize: '0.9rem',
  },
  subtitle: {
    fontSize: '0.7rem',
  },
  chipContainer: {
    padding: '0.5rem 0 0 0',
  },
  chip: {
    cursor: 'pointer',
    margin: '0.1rem',
  },
  actionsNotFound: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1rem 0',
  },
  button: {
    textAlign: 'center',
    width: 'fit-content',
    // margin: '2rem 0',
  }
};

const FormEquipmentsMaintenance = (props) => {
  const dispatch = useDispatch();
  const equipId = props.match.params.id === 'new' ? props.match.params.equip_id : props.match.params.id;
  const matches = useMediaQuery('(min-width:1200px)');

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [infiniteScroll, setInfiniteScroll] = useState(false);


  useEffect(() => {
    setPage(1);
    setInfiniteScroll(false);
  }, []);

  useEffect(() => {
    fetchMaintenancesByEquipment(page, infiniteScroll);
  }, [page, infiniteScroll])

  const fetchMaintenancesByEquipment = useCallback(
    (page, infiniteScroll = false) => dispatch(actions.fetchMaintenancesByEquipment(page,limit,'','desc','createdAt', infiniteScroll, equipId.toString())),
    [equipId]
  );

  const loadingInfiniteScroll = useSelector(state => state.maintenances.loadingInfiniteScroll);
  const timelineMaintenances = useSelector(state => state.maintenances.timelineMaintenances);
  const loadingMaintenances = useSelector(state => state.maintenances.timelineMaintenancesLoading);
  const handleClearMaintenance = useCallback(() => dispatch(actions.clearMaintenanceInfo()));

  const selectedAccess = useSelector((state) => state.auth.selectedAccess)
  const role = selectedAccess.role

  const isAnalyst = role === EAccessRole.analyst;
  const isContractor = role === EAccessRole.contractor;
  const isInspector = selectedAccess.inspector && (isAnalyst || isContractor);

  useEffect(() => {
    handleClearMaintenance();
    fetchMaintenancesByEquipment();
  }, [equipId]);

  const handleClickMaintenance = (maintenanceId) => {
    props.history.push(`/form-maintenance/${maintenanceId}/${equipId}`);
  };

  const handleLoadMore = () => {
    setPage(prev => prev + 1);
    setInfiniteScroll(true);
  }

  return (
    <>
      <Tabs {...props} selected={'maintenanceTab'} />
      <Container maxWidth='md' style={styles.container}>
          <div style={{textAlign: 'center', padding: '5px'}}>
            <Button
              style={{margin: '2rem 0', ...styles.button}}
              variant='outlined'
              aria-label="add"
              startIcon={<AddCircleOutline />}
              disabled={isInspector}
              onClick={() => props.history.push(`/form-maintenance/new/${equipId}`)}
            >
              {i18n.t('maintenancesTab.button')}
            </Button>
          </div>
          {!loadingMaintenances && timelineMaintenances?.rows?.length === 0 &&
          <div style={styles.actionsNotFound}>{i18n.t('maintenancesTab.text')}</div>}

          {loadingMaintenances && <Spinner />}
          {!loadingMaintenances && equipId && timelineMaintenances?.rows?.length > 0 && <Timeline data={timelineMaintenances} spinner={loadingMaintenances} handleMaintenance={handleClickMaintenance} /> }

          <div style={{textAlign: 'center', marginTop: '10px'}}>
            {loadingInfiniteScroll && <Spinner />}
            { !loadingInfiniteScroll && timelineMaintenances.count > 0 && timelineMaintenances.count > timelineMaintenances.rows.length &&
              <Button style={styles.button} variant='outlined' onClick={handleLoadMore}>{i18n.t('maintenancesTab.loadMoreButton')}</Button>
            }
          </div>       
        </Container>
    </>
  )
}

export default FormEquipmentsMaintenance;
